<app-page inTutorial="true">
  <buy-creator-coins-tutorial></buy-creator-coins-tutorial>
</app-page>
